import script from "./PaymentsEmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentsEmptyState.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentsEmptyState.vue?vue&type=style&index=0&id=8ca0fe52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ca0fe52"]])

export default __exports__